@if (type() === 'carousel') {
  <mobi-ui-carousel-major [maxColumns]="3" #carousel>
    @for (image of images(); track image?.uuid ?? i; let i = $index) {
      <mobi-media
        [entity]="image"
        responsiveStyle="gallery_slider"
        (click)="openOverlay(i)"
      />
    }
  </mobi-ui-carousel-major>
} @else {
  <div class="mobi-ui-grid smMax:!gap-y-4">
    @for (image of images(); track image?.uuid ?? i; let i = $index) {
      <div
        class="mobi-ui-col-1/1 sm:mobi-ui-col-1/3"
        [ngClass]="{ 'md:mobi-ui-col-1/4': images()!.length > 3 }"
      >
        <button class="group relative block" (click)="openOverlay(i)">
          <mobi-media [entity]="image" responsiveStyle="gallery" />
          <a
            class="mobi-ui-btn-icon-silent download-btn"
            [href]="downloadImage(image)"
            data-track-download
            target="_blank"
          >
            <mobi-ui-icon-major name="download" />
          </a>
        </button>
      </div>
    }
  </div>
}
<!-- Overlay for image gallery -->
<ng-template #overlayTemplate>
  @if (isOverlayOpen() && images()) {
    <div class="image-gallery-overlay" trapFocus>
      <div class="overlay-content-wrapper">
        <button aria-label="Swipe left" (click)="prev()" class="swipe-btn left-0">
          <mobi-ui-icon-major name="left" />
        </button>
        <div class="image-gallery-overlay-top">
          <div class="image-gallery-overlay-pagination mobi-ui-font-bold">
            {{ selectedIndex() + 1 }}/{{ images()!.length }}
          </div>
          <button
            aria-label="Close overlay"
            (click)="closeOverlay()"
            class="hover:opacity-70"
          >
            <mobi-ui-icon-major name="the_x" />
          </button>
        </div>
        @for (image of images(); track image?.uuid ?? i; let i = $index) {
          @if (image && selectedIndex() === i) {
            <div
              class="carousel-item mobi-ui-animation-appear-init mobi-ui-animation-appear-render"
              (swipeleft)="next()"
              (swiperight)="prev()"
              [style.aspectRatio]="
                ((image?.image?.width || 0) + 130) / (image?.image?.height || 0)
              "
            >
              <mobi-media [entity]="image" responsiveStyle="gallery_overlay" />
              <div class="image-legend mobi-ui-padding-x-lg mobi-ui-padding-y-md">
                <div>
                  @if (image.title) {
                    <mobi-text
                      [data]="image.title"
                      class="mobi-ui-font-size-200 mobi-ui-font-bold"
                    />
                  }
                  @if (image.description) {
                    <mobi-text [data]="image.description" />
                  }
                </div>
                <a
                  [href]="downloadImage(image)"
                  data-track-download
                  target="_blank"
                  class="hover:opacity-70 text-black"
                >
                  <mobi-ui-icon-major name="download" />
                </a>
              </div>
            </div>
          }
        }
        <button aria-label="Swipe right" (click)="next()" class="swipe-btn right-0">
          <mobi-ui-icon-major name="right" />
        </button>
      </div>
    </div>
    <button
      class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing !fixed w-full"
      (click)="closeOverlay()"
      (keyup)="closeOverlay()"
    >
      &nbsp;
    </button>
  }
</ng-template>
